import {SET_URNAME,SET_SECURITYQUESTION} from './types';


//创建action生成器
export const setUname = (username)=>({
    type: SET_URNAME,
    payload: username,
});

export const setSecurityQuestion = (securityQuestion)=>({
    type: SET_SECURITYQUESTION,
    payload: securityQuestion,
});

